import PageHero from "@/components/site/PageHero";
import SEO from "@/components/site/SEO";
import { COMPANY } from "@/lib/siteData";

export default function Confidentialite() {
  return (
    <div data-testid="confidentialite-page">
      <SEO
        title="Politique de confidentialité | RM Plomberie Chauffage VMC"
        description="Politique de confidentialité et traitement des données personnelles - RM Plomberie Chauffage VMC, conforme RGPD."
      />
      <PageHero breadcrumb="Confidentialité" title=" confidentialité" highlight="Politique de" />
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-gray-700">
            La présente politique de confidentialité décrit comment {COMPANY.name} collecte et traite vos données personnelles lorsque vous utilisez ce site.
          </p>

          <h2 className="font-display text-2xl font-bold text-[#001B35] mt-10">Données collectées</h2>
          <p className="text-gray-700">
            Lors de l'envoi du formulaire de contact, nous collectons : nom, prénom, téléphone, email, type de demande et contenu du message.
          </p>

          <h2 className="font-display text-2xl font-bold text-[#001B35] mt-10">Finalité</h2>
          <p className="text-gray-700">
            Ces données sont utilisées uniquement pour vous recontacter dans le cadre de votre demande. Aucune donnée n'est transmise à des tiers à des fins commerciales.
          </p>

          <h2 className="font-display text-2xl font-bold text-[#001B35] mt-10">Conservation</h2>
          <p className="text-gray-700">
            Vos données sont conservées pendant une durée maximale de 3 ans à compter du dernier contact.
          </p>

          <h2 className="font-display text-2xl font-bold text-[#001B35] mt-10">Vos droits</h2>
          <p className="text-gray-700">
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition. Pour exercer ces droits, contactez-nous à <a href={`mailto:${COMPANY.email}`} className="text-[#005BBB]">{COMPANY.email}</a>.
          </p>
        </div>
      </section>
    </div>
  );
}
